import React from "react";
import { Box } from "@mui/material";

export const FormHeader = () => (
  <Box sx={{ maxWidth: 800, mx: "auto", mb: 3 }}>
    <Box
      sx={{
        width: "100%",
        height: { xs: 70, sm: 100 },
        backgroundColor: "#163666",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(22,54,102,0.25)",
      }}
    >
      <img
        src="/Sibolab_Logo_white_rgb.png"
        alt="Sibolab Logo"
        style={{ height: "55%", width: "auto" }}
      />
    </Box>
  </Box>
);
